import { Culture } from '../../types';

export const akChin: Culture = {
  name: 'Ak-Chin Indian Community',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Ak-Chin',
      phonetic: 'ahk-chin',
      description: 'Means "mouth of the arroyo" in O\'odham language.'
    },
    {
      word: 'Vechij',
      phonetic: 'veh-chee-j',
      description: 'O\'odham word for "plant" or "tree."'
    },
    {
      word: 'Wii Gi Wosh',
      phonetic: 'wee gee wosh',
      description: 'A phrase meaning "helpful water."'
    }
  ]
};